export enum EmploymentStatus
{
    NewPerson = 1,
    AssignmentGuidance = 2,
    InDepthGuidance = 3,
    InternalGuidance = 6,
    CancelledByParticipant = 7,
    FinishedGuidance = 8,
    Cancelled = 11,
    FinishedCouldNotReach = 12,
}

export const EmploymentStatusText: {
    [key in EmploymentStatus]: string;
    } = {
    [EmploymentStatus.NewPerson]: 'Ny person',
    [EmploymentStatus.AssignmentGuidance]: 'Tilldelning vägledning',
    [EmploymentStatus.InDepthGuidance]: 'Fördjupad vägledning',
    [EmploymentStatus.InternalGuidance]: 'Intern vägledning',
    [EmploymentStatus.CancelledByParticipant]: 'Avbokad av deltagare',
    [EmploymentStatus.FinishedGuidance]: 'Avslutad - vägledning genomförd',
    [EmploymentStatus.Cancelled]: 'Avbruten',
    [EmploymentStatus.FinishedCouldNotReach]: 'Avslutad - ej gått att nå',
}